// eslint-disable-next-line import/no-named-as-default
import DateRequests from '../../requests/holidays/dates.js';

export class DateService {
    static async getHolidays() {
        return DateRequests.getHolidays();
    }
}
